import {createSlice} from "@reduxjs/toolkit";

export const AppSlice = createSlice({
    name: 'app',
    initialState: {
        server: null,
        authTime: null
    },
    reducers: {
        setServer: (state, action) => {
            state.server = action.payload;
        },
        delServer: (state) => {
            state.server = null;
        },
        setAuthTime: (state, action) => {
            state.authTime = action.payload;
        },
        delAuthTime: (state) => {
            state.authTime = null;
        }
    }
})

export const { setServer, delServer, setAuthTime, delAuthTime} = AppSlice.actions;

export default AppSlice.reducer;